import {
  Box,
  Button,
  Center,
  createStyles,
  Flex,
  Grid,
  Group,
  Input,
  Paper,
  rem,
  ScrollArea,
  Select,
  SimpleGrid,
  Table,
  Text,
  TextInput,
  Title,
} from "@mantine/core";
import React, { useEffect, useState } from "react";
import { DropDownArrowSvg } from "../../../components/Svgs/DropDownArrowSvg";
import TableLoader from "../../../components/TableLoader";
import CustomBillingPagination from "../../../components/Pagination/CustomBillingPagination";
// import PaymentAnalytics from "./PaymentAnalytics";
import { IconSearch } from "@tabler/icons-react";

import { IoFilter } from "react-icons/io5";
import swal from "sweetalert";
import { useSelector } from "react-redux";

import { DateInput } from "@mantine/dates";
import { useForm } from "@mantine/form";
import {
  BillingConnectCard,
  // getAllBillingPayments,
  getBillingCard,
  PayBillingAmount,
} from "../../../services";
// import BillingSearchAll from "../../../components/Document/BilllingSearchAll";
import moment from "moment";
import { Tooltip } from "recharts";
import { getStripAccountForInovices } from "../../../services/invoicesetting";
// import PaymentFilter from "../../../components/ClaimBilling/billingPaymentfilter";
import { getSubscriptionCard } from "../../../services/subscription";

const useStyles = createStyles((theme) => ({
  paymentTab: {
    width: "100%",
    padding: "1rem",
    borderRadius: "4px",
    backgroundColor: "white",
    marginBottom: "1rem",
  },

  myinput: {
    width: "30%",
    marginTop: "20px",
    marginBottom: "20px",

    "@media (max-width:1200px)": {
      width: "100%",
    },
  },

  rejected: {
    padding: "2px 8px 2px 6px",
    width: "52%",
    margin: "auto 0",
    borderRadius: "16px",
    background: "#FEF3F2",
  },

  accepted: {
    padding: "2px 8px 2px 6px",
    width: "52%",
    margin: "auto 0",
    borderRadius: "16px",
    background: "#ECFDF3",
  },

  pending: {
    padding: "2px 8px 2px 6px",
    width: "52%",
    margin: "auto 0",
    borderRadius: "16px",
    background: "#F9F5FF",
  },

  header: {
    fontFamily: "Inter",
    fontSize: "14px",
    fontWeight: "700",
    color: "var(--app-text)",
  },

  tabList: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    gap: "1rem",
    paddingBottom: "0.5rem",
    marginBottom: "1rem",
    fontFamily: "Inter",
  },
  tab: {
    cursor: "pointer",
    fontWeight: "normal",
    fontSize: "14px",
    lineHeight: "1.35",
    padding: "0.5rem 1rem",
    backgroundColor: "var(--app-surface)",
    borderRadius: "12px",
    border: "2px solid #E4E4E7",
  },
  activeTab: {
    backgroundColor: "var(--app-surface)",
    border: "2px solid var(--app-accent)",
  },
  paymentContainer: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },

  filledpaymentContainer: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flexDirection: "column",
    gap: "20px",
    border: "2px solid black",
    background: "var(--app-primary)",
    width: "50%",
    borderRadius: "6%",
    margin: "auto",
  },

  paymentForm: {
    width: "450px",
    display: "flex",
    flexDirection: "column",
    gap: ".5rem",
  },
  achForm: {
    display: "flex",
    flexDirection: "column",
    gap: ".5rem",
  },
  title: {
    color: "#101828",
    textAlign: "center",
    fontFamily: "Inter, sans-serif",
    fontSize: "30px",
    fontStyle: "normal",
    fontWeight: 600,
    lineHeight: "38px",
    marginTop: "20px",
    marginBottom: "30px",
  },
  text: {
    color: "var(--app-text-muted)", // Gray-500
    textAlign: "center",
    fontFamily: "Inter, sans-serif",
    fontSize: "16px",
    fontStyle: "normal",
    fontWeight: 400,
    lineHeight: "24px",
  },

  paymenttype: {
    color: "#27272A", // Gray-500
    textAlign: "center",
    fontFamily: "Inter, sans-serif",
    fontSize: "16px",
    fontStyle: "normal",
    fontWeight: 600,
    lineHeight: "24px",
    marginTop: "45px",
    marginBottom: "12px",
  },

  searchInput: {
    width: "45%",
    marginBlock: "10px",
    borderRadius: "18px",
    "& :focus-within": {
      border: "1px solid var(--app-border)",
    },
    "& :focus": {
      border: "1px solid var(--app-border)",
    },
    "& :hover": {
      border: "1px solid var(--app-border)",
    },
    "& :active": {
      border: "1px solid var(--app-border)",
    },
    "& :focus-visible": {
      border: "1px solid var(--app-border)",
    },
  },
  bg1: {
    "& td": {
      background: "var(--app-surface)",
    },
  },
  bg2: {
    "& td": {
      background: "var(--app-surface-2)",
    },

    wrapper: {
      borderColor: "#97979726",
      borderWidth: 1,
      borderRadius: 14,
      borderStyle: "solid",
      display: "flex",
      flexDirection: "column",
    },
    wrapper_select: {
      background: "#232323",
    },
    plantype: {
      fontFamily: "Inter",
      fontSize: 20,
      fontWeight: 500,
      color: "var(--app-on-primary)",
    },
    price: {
      fontFamily: "Inter",
      fontSize: 22,
      color: "#232323",
      fontWeight: 600,
    },
    unit: {
      fontFamily: "Inter",
      fontSize: 25,
      color: "var(--app-text-muted)",
    },
    period: {
      fontFamily: "Inter",
      fontSize: 16,
      color: "var(--app-text-muted)",
    },
    title: {
      display: "flex",
      flexDirection: "row",
      margin: 20,
    },
    pricetag: {
      marginLeft: "auto",
      margin: "1px solid green",
      fontSize: "13 !important",
    },
    desc: {
      fontFamily: "Inter",
      fontSize: 16,
      color: "var(--app-text-muted)",
    },
    descbox: {
      marginLeft: 20,
      marginRight: 20,
      marginBottom: 15,
    },
    btnbox: {
      display: "flex",
      flexDirection: "row",
      // marginLeft: 20,
      // marginRight: 20,
      // marginBottom: 20,
      marginTop: "30px",
    },
    btn: {
      // width: 200,
      fontFamily: "Inter",
      fontSize: 16,
      fontWeight: 500,
      marginLeft: "auto",
    },
    reNewbtn: {
      fontFamily: "Inter",
      fontSize: 14,
      fontWeight: 500,
      margin: 10,
      width: 180,
    },
    billing: {
      fontFamily: "Inter",
      fontSize: 14,
      color: "var(--app-text-muted)",
    },
    cycle: {
      fontFamily: "Inter",
      fontSize: 16,
      color: "white",
    },
    selectedtype: {
      fontFamily: "Inter",
      fontSize: 20,
      fontWeight: 500,
      color: "white",
    },
    selectedPrice: {
      fontFamily: "Inter",
      fontSize: 22,
      color: "white",
      fontWeight: 600,
    },
  },

  centered: {
    alignItems: "center",
    display: "flex",
    flexDirection: "column",
    textAlign: "center",
    marginTop: rem(50),
    // margin: "auto",
  },
  update: {
    color: "var(--app-on-primary)",
    fontWeight: 600,
    textDecoration: "none",
    borderBottom: "1px solid var(--app-surface)",
  },
  title: {
    fontSize: rem(34),
    fontWeight: 700,
    fontFamily: "Inter",
    marginBottom: rem(10),
  },
  paymentFailedBox: {
    background: "#ff00009e",
    color: "#FFFF",
    padding: 20,
    borderRadius: 10,
    // marginTop: 10,
    marginBottom: 10,
    fontFamily: "Inter",
    textAlign: "center",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    width: "100%",
  },
  description: {
    fontSize: rem(16),
    fontWeight: 400,
    fontFamily: "Inter",
    color: "var(--app-text-muted)",
  },
  logo: {
    marginTop: rem(30),
    marginBottom: rem(40),
  },
  type: {
    borderWidth: 1,
    borderRadius: 10,
    borderColor: "#97979726",
    borderStyle: "solid",
    padding: 20,
  },
  selected: {
    borderWidth: 1,
    borderRadius: 10,
    borderColor: "var(--app-primary)",
    borderStyle: "solid",
    padding: 20,
  },
  myfont: {
    fontFamily: "Inter",
    background: "var(--app-surface)",
  },
  card: {
    width: "100%",
    marginTop: 0,
    overflow: "unset",
  },
  payBtn: {
    fontFamily: "Inter",
    marginTop: rem(50),
    marginBottom: rem(20),
  },
  m10: {
    marginTop: rem(10),
    marginBottom: rem(10),
  },
  font1: {
    fontSize: rem(20),
    fontWeight: 500,
    fontFamily: "Inter",
    cursor: "pointer",
  },
  font2: {
    fontSize: rem(16),
    fontWeight: 400,
    fontFamily: "Inter",
    color: "var(--app-text-muted)",
  },
  back: {
    position: "absolute",
    top: rem(50),
    left: rem(50),
    fontSize: rem(16),
    fontFamily: "Inter",
    fontWeight: 500,
    "@media (max-width: 1024px)": {
      top: rem(100),
    },
  },
  plaidComponent: {
    // cursor: "pointer",
    border: "1px solid var(--app-border)",
    borderRadius: "10px",
    width: "65%",
    "@media (max-width: 900px)": {
      width: "80%",
    },
    "@media (max-width: 768px)": {
      width: "90%",
    },
  },
  connectBankImage: {
    width: "30%",
    "@media (max-width: 500px)": {
      width: "100%",
    },
  },
  insideFlex: {
    width: "60%",
    "@media (max-width: 500px)": {
      width: "95%",
      padding: "10px",
    },
  },

  // tabContent: {},
}));
 
export const PaymentTab = ({ setPaymentType, setAchServices, achservices }) => {
  const { profile } = useSelector((state) => state?.profile);
  const { /* allbillingPayments, */ billingcard } = useSelector(
    (state) => state.billing
  );

console.log('billingcard',billingcard);

  const [subscriptionCard, setSubscriptionCard] = useState(null);


  const form = useForm({
    initialValues: {
      cardName: "",
      cardNumber: "",
      CVV: "",
      cardMonth: null,
      cardYear: null,
    },
    // validate: {
    //   nameCard: (value) => (value ? null : "Please add card name"),
    //   cardNumber: (value) =>
    //     value && value?.length <= 16 ? null : "Please add a valid card number",
    //   cardExp: (value) => (value ? null : "Select expiry date"),
    //   CVV: (value) => {
    //     const isValidLength =
    //       value && (value?.length === 3 || value?.length === 4);
    //     return isValidLength ? null : "Please add a valid number";
    //   },
    // },

    validate: (values) => {
      const errors = {};

      if (!values.cardName) {
        errors.cardName = "Please add card name";
      }

      if (!values.cardNumber || values.cardNumber.length !== 16) {
        errors.cardNumber = "Please add a valid card number";
      }

      // if (!values.cardExp) {
      //   errors.cardExp = "Select expiry date";
      // }

      const isValidcardMonthLength =
        values.cardMonth && values.cardMonth.length === 2;
      if (!values.cardMonth || !isValidcardMonthLength) {
        errors.cardMonth = "Please add a valid month";
      }

      const isValidcardYearLength =
        values.cardYear && values.cardYear.length === 2;
      if (!values.cardYear || !isValidcardYearLength) {
        errors.cardYear = "Please add a valid Year";
      }

      // cardMonth: (value) => {
      //   const isValidLength = value && value.length === 2;
      //   return isValidLength ? null : "Please add a valid month";
      // },
      // cardYear: (value) => {
      //   const isValidLength = value && value.length === 2;
      //   return isValidLength ? null : "Please add a valid year";
      // },

      const isValidCVVLength =
        values.CVV && (values.CVV.length === 3 || values.CVV.length === 4);
      if (!values.CVV || !isValidCVVLength) {
        errors.CVV = "Please add a valid number";
      }

      return errors;
    },
  });

  const [loading, setLoading] = useState(false);

  const { classes, cx } = useStyles();
  const icon = (
    <DropDownArrowSvg
      color={"var(--app-text)"}
      style={{ width: rem(1), height: rem(1) }}
    />
  );

  const [activeTab, setActiveTab] = useState("debit-credit");
  const [selectedOption, setSelectedOption] = useState("");
  // const [searchTerm, setSearchTerm] = useState("");
  // const [currentPage, setCurrentPage] = useState(1);
  // const [filtermodal, setFilterModal] = useState(false);


  const [active, setActive] = useState(false);
  const [fetchingData, setFetchingData] = useState(true);


  useEffect(()=>{
      getStripAccountForInovices()

  },[])

  // console.log('loading',loading);
  const formatDate = (date) => {
    if (!(date instanceof Date) || isNaN(date.getTime())) return "Invalid Date";
    const yyyy = date.getFullYear();
    const mm = String(date.getMonth() + 1).padStart(2, "0");
    const dd = String(date.getDate()).padStart(2, "0");
    return `${yyyy}-${mm}-${dd}`;
  };

  useEffect(() => {
    setSelectedOption("paymentSetting");
  }, []);

  const onSave = async (id) => {
    const willDelete = await swal({
      title: `Are you sure you want to do this actions?`,
      text: "This action cannot be undone.",
      icon: "warning",
      dangerMode: true,
      buttons: ["No", "Yes"],
    });

    if (willDelete) {
      setLoading(true);
      let payload = {
        paymentid: id,
        admin: profile.user.id,
      };
      let res = await PayBillingAmount(payload);
      if (res?.status === 200) {
        swal({
          title: `Payment done successfully`,
          text: "Payment done successful",
          dangerMode: false,
          icon: "success",
        });
      }
    }
    setLoading(false);
  };

  // const SearchBilling = async (searchTerm) => {
  //   try {
  //     await getAllBillingPayments({ name: searchTerm });
  //   } catch (error) {
  //     console.error("API call error:", error);
  //   }
  // };

  useEffect(() => {
    const checkPaymentData = async () => {
      // setFetchingData(true);
      if (billingcard?.BillingPayment) {
        setActive(true);
        setFetchingData(false);
      } else {
        const res = await getSubscriptionCard();
        if (res?.status === 200 && res?.data) {
          setSubscriptionCard(res?.data);
          setActive(true);
        } else {
          setActive(false);
        }
        setFetchingData(false);
      }
    };
    checkPaymentData();
  }, [billingcard]);

  useEffect(() => {
    if (form.getInputProps("cardNumber")?.value?.length > 16) {
      form.setFieldValue(
        "cardNumber",
        form.getInputProps("cardNumber")?.value?.slice(0, 16)
      );
    }
  }, [form.getInputProps("cardNumber")?.value]);

  useEffect(() => {
    if (form.getInputProps("CVV")?.value?.length > 4) {
      form.setFieldValue("CVV", form.getInputProps("CVV")?.value?.slice(0, 4));
    }
  }, [form.getInputProps("CVV")?.value]);

  useEffect(() => {
    if (form.getInputProps("cardMonth")?.value?.length > 2) {
      form.setFieldValue(
        "cardMonth",
        form.getInputProps("cardMonth")?.value?.slice(0, 2)
      );
    }
  }, [form.getInputProps("cardMonth")]);

  useEffect(() => {
    if (form.getInputProps("cardYear")?.value?.length > 2) {
      form.setFieldValue(
        "cardYear",
        form.getInputProps("cardYear")?.value?.slice(0, 2)
      );
    }
  }, [form.getInputProps("cardYear")]);

  //  console.log('selectedOption',selectedOption);

  //   useEffect(() => {
  //     if (debouncedSearch) {
  //       getTodaysNotes(debouncedSearch);
  //     } else {
  //       getTodaysNotes("");
  //     }
  //   }, [debouncedSearch, getTodaysNotes]);
  // AllPaymentTable component removed — payments data moved to Receipts tab

  const onFinish = async (values) => {
    // console.log("values", values);

    const { cardMonth, cardYear } = values;
    let obj = {
      ...values,
      user: profile?.user?.id,
      paymentMethod: "card",
      cardExp: `${cardMonth}/${cardYear}`,
      // email: profile?.user?.email,
      // businessId: profile?.business?.id
    };

    console.log("obj", obj);

    const willDelete = await swal({
      title: `Are you sure?`,
      text: "This action cannot be undone. This Credit Card will be used for Billing",
      icon: "warning",
      dangerMode: true,
      buttons: ["Cancel", "Proceed"],
    });
    if (willDelete) {
      setLoading(true);
      let res = await BillingConnectCard(obj);

      setPaymentType(activeTab);

      if (res.status === 200) {
        await swal({
          title: "Card Connected",
          text: `Your Default Payment Card has Selected For Payment`,
          icon: "success",
          dangerMode: false,
        });
        setActive(true);
        // await getBillingCard();
      }

      setLoading(false);
    }
  };



 const { stripeaccounts  } = useSelector(
    (state) => state.settinginvoice
  );

//  console.log('stripeaccounts tets',stripeaccounts.StripeAccounts.stripeAccountdetails.requirements?.currently_due);


const status = stripeaccounts?.StripeAccounts?.stripeAccountStatus;

console.log('status',status);


  // BillingConnectCard

  const cardconnect = async (values) => {
    // console.log('va');
    //     const dummyAccountNumber = '123456789';
    // const dummyRoutingNumber = '021000021';

    let obj = {
      accountNumber: achservices.accountNumber,
      routingNumber: achservices.routingNumber,
      user: profile?.user?.id,
      paymentMethod: "ach",
      bankName: achservices.bankName,
      accountholdername: achservices.accountholdername,
      accountholdertype: "individual",
      // email: profile?.user?.email,
      // businessId: profile?.business?.id
    };

    console.log("obj", obj);
    let res;

    const willDelete = await swal({
      title: `Are you sure?`,
      text: "This Bank Account will be used to collect fees associated with filing a claim on Ogiso",
      icon: "warning",
      dangerMode: true,
      buttons: ["Cancel", "Proceed"],
    });
    if (willDelete) {
      res = await BillingConnectCard(obj);

      if (res.status === 200) {
        setActive(true);
        // await getBillingCard();
      }

      setPaymentType(activeTab);
      // await swal({
      //   title: "Card Connected",
      //   text: `Your Default Payment Card has Selected For Payment`,
      //   icon: "success",
      //   dangerMode: false,
      // });

      // let response = null;

      // });
    }

    console.log("res", res);

    if (res.status === 200)
      await swal({
        title: "Card Connected",
        text: `Your Default Payment Card has Selected For Payment`,
        icon: "success",
        dangerMode: false,
      });

    setPaymentType(activeTab);

    // setState({ ...state, reviewclaim: true, payment: false });
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setAchServices((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  // const handlePageChange = async (pageNumber) => {
  //   setLoading(true);
  //   setCurrentPage(pageNumber);
  //   await getAllBillingPayments({ page: pageNumber });
  //   setLoading(false);
  // };
  // console.log('achservices',achservices);

  return (
    <Box className={classes.paymentTab} style={{ minHeight: "500px" }}>
      <Select
        variant="unstyled"
        placeholder="Select Payment"
        rightSection={icon}
        // defaultValue={"paymentSetting"}
        value={selectedOption}
        onChange={(value) => setSelectedOption(value)}
        data={[
          { value: "paymentSetting", label: "Payment Setting" },
          // { value: "allPayments", label: "All Payments" },
        ]}
        w={200}
      />

       {selectedOption === "paymentSetting" && (
        <>
          {fetchingData ? (
             <TableLoader />
          ) : !active ? (
            <Box className={classes.paymentContainer}>
              <Box className={classes.paymentForm}>
                <Title className={classes.title}>Add Payment Information</Title>
                <Text className={classes.text}>
                  Kindly follow the instructions below to add a bank account
                </Text>

                <Text ta={"left"} className={classes.paymenttype}>
                  Select Payment Type
                </Text>

                <Box className={classes.tabList}>
                  {[
                    { value: "debit-credit", label: "Debit/Credit Card" },
                    { value: "ach", label: "ACH" },
                  ].map((tab) => (
                    <Box
                      key={tab.value}
                      className={cx(classes.tab, {
                        [classes.activeTab]: activeTab === tab.value,
                      })}
                      onClick={() => setActiveTab(tab.value)}
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "8px",
                      }}
                    >
                      {tab.label}
                      {activeTab === tab.value && (
                        <img
                          width={20}
                          height={20}
                          style={{ marginRight: "18px" }}
                          src="/assets/images/Check icon.png"
                          alt="check-icon"
                        />
                      )}
                    </Box>
                  ))}
                </Box>

                <Box className={classes.tabContent}>
                  {activeTab === "debit-credit" && (
                    <>
                      <form
                        onSubmit={form.onSubmit((values) => onFinish(values))}
                      >
                        <Box className={classes.inputs}>
                          <TextInput
                            size="lg"
                            variant="filled"
                            label="Name on Card"
                            placeholder="Eg. abc"
                            {...form.getInputProps("cardName")}
                            className={[classes.myfont, classes.m10]}
                          />
                        </Box>

                        <Box className={classes.inputs}>
                          <TextInput
                            size="lg"
                            type="number"
                            variant="filled"
                            label="Card Number"
                            className={classes.myfont}
                            placeholder="Eg. 5952 **** **** ****"
                            {...form.getInputProps("cardNumber")}
                          />
                          {form.errors.cardNumber && (
                            <Box style={{ color: "red" }}>
                              {form.errors.cardNumber.message}
                            </Box>
                          )}
                        </Box>

                        <Grid align="flex-end">
                          <Grid.Col xs={12} sm={12} md={6}>
                            <Grid>
                              <Grid.Col
                                className={classes.marginTop}
                                xs={12}
                                sm={12}
                                md={6}
                              >
                                {/* ----- card month ----- */}
                                <TextInput
                                  size="lg"
                                  type="number"
                                  variant="filled"
                                  placeholder="MM"
                                  className={classes.myfont}
                                  {...form.getInputProps("cardMonth")}
                                />
                              </Grid.Col>
                              {/* ----- card year ----- */}
                              <Grid.Col xs={12} sm={12} md={6}>
                                <TextInput
                                  size="lg"
                                  type="number"
                                  variant="filled"
                                  placeholder="YY"
                                  className={classes.myfont}
                                  {...form.getInputProps("cardYear")}
                                />
                              </Grid.Col>
                            </Grid>
                          </Grid.Col>
                          <Grid.Col xs={12} sm={12} md={6}>
                            <TextInput
                              size="lg"
                              label="CVV"
                              type="number"
                              variant="filled"
                              placeholder="Eg.***"
                              className={classes.myfont}
                              {...form.getInputProps("CVV")}
                            />
                          </Grid.Col>
                        </Grid>

                        <Button
                          type="submit"
                          style={{ marginTop: "20px" }}
                          variant="filled"
                          size="md"
                          loading={loading}
                          radius="md"
                          label="Connect"
                          color="yellow"
                          w={"100%"}
                        >
                          Connect
                        </Button>
                      </form>
                    </>
                  )}

                  {activeTab === "ach" && (
                    <Box className={classes.achForm}>
                      <label>Account Number</label>
                      <Input
                        type="number"
                        placeholder="Eg. abc"
                        title="Account Number"
                        label="Account Number"
                        size="md"
                        radius="md"
                        name="accountNumber"
                        onChange={handleInputChange}
                      />
                      <label>Routing Number</label>
                      <Input
                        type="number"
                        title="Routing Number"
                        label="Routing Number"
                        size="md"
                        radius="md"
                        name="routingNumber"
                        onChange={handleInputChange}
                      />
                      <label>Bank Name</label>
                      <Input
                        type="text"
                        title="Bank Name"
                        label="Bank Name"
                        size="md"
                        radius="md"
                        name="accountholdername"
                        onChange={handleInputChange}
                      />
                      <label>Account Holder Name</label>
                      <Input
                        type="text"
                        title="Account Holder Name"
                        label="Account Holder Name"
                        size="md"
                        radius="md"
                        name="bankName"
                        onChange={handleInputChange}
                      />
                      <Button
                        mt={20}
                        variant="filled"
                        onClick={cardconnect}
                        size="md"
                        radius="md"
                        label="Connect"
                        color="yellow"
                        w={"100%"}
                      >
                        Connect
                      </Button>
                    </Box>
                  )}
                </Box>
              </Box>
            </Box>
          ) : (
            <Box className={classes.filledpaymentContainer}>
              <Box
                style={{
                  marginTop: "20px",
                  marginBottom: "30px",
                }}
                className={classes.title}
              >
                <Group>
                  <img
                    src={"/assets/images/personal.png"}
                    alt=""
                    width={40}
                    height={40}
                  />
                  <Text fz={16} fw={700} color="var(--app-on-primary)">
                    {(billingcard?.BillingPayment?.paymentMethod === "card" || subscriptionCard?.creditCard)
                      ? "Card"
                      : "Bank Account"}
                  </Text>
                </Group>
              </Box>
              <Box className={classes.descbox}>
                {((billingcard?.BillingPayment?.isActive || subscriptionCard?.isActive) &&
                (billingcard?.BillingPayment?.paymentMethod === "card" || subscriptionCard?.creditCard)) ? (
                  <>
                    <Text fz={16} fw={400} color="var(--app-on-primary)">
                      Card Holder Name:{" "}
                      {billingcard?.BillingPayment?.cardName || subscriptionCard?.cardName || ""}
                    </Text>
                    <Text fz={16} fw={400} color="var(--app-on-primary)">
                      last Four digits:{" "}
                      {billingcard?.BillingPayment?.cardNumber || subscriptionCard?.cardNumber || ""}
                    </Text>

                    {(billingcard?.BillingPayment?.expiry_year || billingcard?.BillingPayment?.expiry_month) && (
                      <Text fz={16} fw={400} color="var(--app-on-primary)">
                        Expiry date: {billingcard?.BillingPayment?.expiry_year}/
                        {String(
                          billingcard?.BillingPayment?.expiry_month
                        ).padStart(2, "0")}
                      </Text>
                    )}
                  </>
                ) : (
                  <>
                    <Text fz={16} fw={400} color="var(--app-on-primary)">
                      Bank Name:{" "}
                      {billingcard?.BillingPayment?.bankName ||
                        billingcard?.BillingPayment?.cardName}
                    </Text>
                    <Text fz={16} fw={400} color="var(--app-on-primary)">
                      routing Number:{" "}
                      {billingcard?.BillingPayment?.routingNumber ||
                        billingcard?.BillingPayment?.cardNumber}
                    </Text>
                  </>
                )}
              </Box>
              <Box
                style={{ marginTop: "20px", marginBottom: "20px" }}
                className={classes.btnbox}
              >
                {!billingcard?.isActive && (
                  <Button
                    onClick={() => {
                      setActive(false);
                    }}
                    disabled={profile?.user?.role}
                    className={classes.btn}
                    color="yellow"
                    radius={8}
                  >
                    Create New Account
                  </Button>
                )}
              </Box>
            </Box>
          )}
        </>
      )}

      {/* {selectedOption === "allPayments" && (
        <Box className={classes.paymentTable}>
          <PaymentAnalytics data={allbillingPayments} loading={false} />
          <Box className={classes.allPayment}>
            <Flex justify={"space-between"} align={"center"}>
              <Box className={classes.myinput}>
                <BillingSearchAll
                  placeholder="Search Provider name, Payer name,Claim id"
                  onChange={SearchBilling}
                  value={searchTerm}
                  setValue={setSearchTerm}
                />
              </Box>
              <Button onClick={() => { setFilterModal(true); }} justify="center" variant="default" radius={"md"}>
                <Flex justify={"space-between"} align={"center"} gap={"0.5rem"}>
                  <IoFilter color={"var(--app-text)"} />
                  Filter
                </Flex>
              </Button>
            </Flex>
            <AllPaymentTable />
          </Box>
        </Box>
      )} */}
{/* <PaymentFilter filtermodal={filtermodal} setFilterModal={setFilterModal} /> */}



    </Box>
  );
};
